
(function() {
	var switchTo5x=true;
	var e=document.createElement("script");
	e.type="text/javascript";
	e.async=true;
	e.onload=function() {
		try {
			stLight.options({
				publisher: "6d5be87d-2b8f-4e73-a526-97ae308ea596",
				shorten:false,
				doNotHash: true,
				onhover: false
			});
		} catch(e) { throw e; }
	};
	e.src=('https:' == document.location.protocol ? 'https://ws' : 'http://w') + '.sharethis.com/button/buttons.js';
	// var s = document.getElementsByTagName('script')[0];
	// s.parentNode.insertBefore(e, s);
	document.body.appendChild(e);
}());
